/* Valmar — custom section scripts (vanilla, no dependencies) */
(function () {
  if (window.__vmInit) return;
  window.__vmInit = true;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = null;

  function observer() {
    if (io || !('IntersectionObserver' in window)) return io;
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('vm-visible');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.12 });
    return io;
  }

  function initReveals(root) {
    var els = (root || document).querySelectorAll('.vm-reveal:not(.vm-visible), .vm-ring:not(.vm-visible)');
    var obs = observer();
    els.forEach(function (el) {
      if (!obs || reduce) { el.classList.add('vm-visible'); return; }
      obs.observe(el);
    });
  }

  /* Hero zoom-out + staggered text */
  function initHero(root) {
    (root || document).querySelectorAll('[data-vm-hero]').forEach(function (hero) {
      if (hero.dataset.vmInit) return;
      hero.dataset.vmInit = '1';
      var img = hero.querySelector('.vm-hero__media img');
      var go = function () { requestAnimationFrame(function () { hero.classList.add('is-loaded'); }); };
      if (!img || img.complete) go(); else { img.addEventListener('load', go); img.addEventListener('error', go); setTimeout(go, 1800); }
    });
  }

  /* Bento cards: cursor glare */
  function initCards(root) {
    if (window.matchMedia('(hover: none)').matches) return;
    (root || document).querySelectorAll('.vm-card').forEach(function (card) {
      if (card.dataset.vmInit) return;
      card.dataset.vmInit = '1';
      card.addEventListener('pointermove', function (e) {
        var r = card.getBoundingClientRect();
        card.style.setProperty('--mx', (e.clientX - r.left) + 'px');
        card.style.setProperty('--my', (e.clientY - r.top) + 'px');
      });
    });
  }

  /* Sticky ritual: steps activate images */
  function initRitual(root) {
    (root || document).querySelectorAll('[data-vm-ritual]').forEach(function (sec) {
      if (sec.dataset.vmInit) return;
      sec.dataset.vmInit = '1';
      var steps = sec.querySelectorAll('.vm-ritual__step');
      var imgs = sec.querySelectorAll('.vm-ritual__frame img');
      var dots = sec.querySelectorAll('.vm-ritual__dot');
      if (!steps.length) return;
      function activate(i) {
        steps.forEach(function (s, k) { s.classList.toggle('is-active', k === i); });
        imgs.forEach(function (im, k) { im.classList.toggle('is-active', k === i); });
        dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); d.classList.toggle('is-done', k < i); });
      }
      activate(0);
      if (!('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) activate(Array.prototype.indexOf.call(steps, e.target));
        });
      }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
      steps.forEach(function (s) { obs.observe(s); });
    });
  }

  /* Manifesto: light words progressively while scrolling */
  var manifestos = [];
  function initManifesto(root) {
    (root || document).querySelectorAll('[data-vm-manifesto]').forEach(function (sec) {
      if (sec.dataset.vmInit) return;
      sec.dataset.vmInit = '1';
      var words = sec.querySelectorAll('.vm-w');
      if (reduce) { words.forEach(function (w) { w.classList.add('is-lit'); }); return; }
      manifestos.push({ sec: sec, words: words });
    });
    updateManifestos();
  }
  function updateManifestos() {
    var vh = window.innerHeight;
    manifestos.forEach(function (m) {
      if (!document.body.contains(m.sec)) return;
      var r = m.sec.getBoundingClientRect();
      var start = vh * 0.85, end = vh * 0.25;
      var p = (start - r.top) / (start - end + r.height * 0.55);
      p = Math.max(0, Math.min(1, p));
      var lit = Math.round(p * m.words.length);
      m.words.forEach(function (w, i) { w.classList.toggle('is-lit', i < lit); });
    });
  }

  /* CTA parallax */
  var parallaxEls = [];
  function initParallax(root) {
    if (reduce) return;
    (root || document).querySelectorAll('[data-vm-parallax]').forEach(function (el) {
      if (el.dataset.vmInit) return;
      el.dataset.vmInit = '1';
      parallaxEls.push(el);
    });
    updateParallax();
  }
  function updateParallax() {
    var vh = window.innerHeight;
    parallaxEls.forEach(function (el) {
      var host = el.parentElement;
      if (!host || !document.body.contains(el)) return;
      var r = host.getBoundingClientRect();
      if (r.bottom < 0 || r.top > vh) return;
      var strength = parseFloat(el.dataset.vmParallax) || 0;
      var p = (r.top + r.height / 2 - vh / 2) / (vh / 2 + r.height / 2);
      el.style.transform = 'translate3d(0,' + (p * strength).toFixed(1) + '%,0)';
    });
  }

  var ticking = false;
  window.addEventListener('scroll', function () {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { updateManifestos(); updateParallax(); ticking = false; });
  }, { passive: true });
  window.addEventListener('resize', function () { updateManifestos(); updateParallax(); });

  /* FAQ accordion */
  function initFaq(root) {
    (root || document).querySelectorAll('[data-vm-faq]').forEach(function (list) {
      if (list.dataset.vmInit) return;
      list.dataset.vmInit = '1';
      list.querySelectorAll('.vm-faq__q').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var item = btn.closest('.vm-faq__item');
          var open = !item.classList.contains('is-open');
          if (list.dataset.vmSingle === 'true') {
            list.querySelectorAll('.vm-faq__item.is-open').forEach(function (o) {
              if (o !== item) { o.classList.remove('is-open'); o.querySelector('.vm-faq__q').setAttribute('aria-expanded', 'false'); }
            });
          }
          item.classList.toggle('is-open', open);
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
      });
    });
  }

  /* Product: gallery + variants + quantity */
  function formatMoney(cents, format) {
    var value = (cents / 100);
    var withComma = function (n, d) { return n.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    var m = (format || '${{amount}}').match(/\{\{\s*(\w+)\s*\}\}/);
    var out;
    switch (m ? m[1] : 'amount') {
      case 'amount_no_decimals': out = withComma(Math.round(value), 0); break;
      case 'amount_with_comma_separator': out = value.toFixed(2).replace('.', ','); break;
      case 'amount_no_decimals_with_comma_separator': out = Math.round(value).toString(); break;
      default: out = withComma(value, 2);
    }
    return (format || '${{amount}}').replace(/\{\{\s*\w+\s*\}\}/, out);
  }

  function initProduct(root) {
    (root || document).querySelectorAll('[data-vm-product]').forEach(function (sec) {
      if (sec.dataset.vmInit) return;
      sec.dataset.vmInit = '1';

      var mains = sec.querySelectorAll('.vm-gallery__main img');
      var thumbs = sec.querySelectorAll('.vm-gallery__thumb');
      var current = 0;
      function show(i) {
        if (!mains.length) return;
        current = (i + mains.length) % mains.length;
        mains.forEach(function (im, k) { im.classList.toggle('is-active', k === current); });
        thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === current); t.setAttribute('aria-current', k === current ? 'true' : 'false'); });
        var active = mains[current];
        if (active && active.loading === 'lazy') active.loading = 'eager';
      }
      thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
      var prev = sec.querySelector('.vm-gallery__nav--prev');
      var next = sec.querySelector('.vm-gallery__nav--next');
      if (prev) prev.addEventListener('click', function () { show(current - 1); });
      if (next) next.addEventListener('click', function () { show(current + 1); });
      var mainWrap = sec.querySelector('.vm-gallery__main');
      if (mainWrap) {
        var sx = null;
        mainWrap.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        mainWrap.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) show(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }
      function showMedia(id) {
        if (!id) return;
        mains.forEach(function (im, k) { if (String(im.dataset.mediaId) === String(id)) show(k); });
      }

      var dataEl = sec.querySelector('[data-vm-variants]');
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]'); } catch (err) { variants = []; }
      var moneyFormat = sec.dataset.moneyFormat;
      var idInput = sec.querySelector('input.product-variant-id');
      var priceEl = sec.querySelector('[data-vm-price]');
      var compareEl = sec.querySelector('[data-vm-compare]');
      var badgeEl = sec.querySelector('[data-vm-badge]');
      var btn = sec.querySelector('.product-form__submit');
      var btnText = btn ? btn.querySelector('span') : null;
      var labels = { add: sec.dataset.labelAdd, sold: sec.dataset.labelSold, unavailable: sec.dataset.labelUnavailable };
      var fieldsets = sec.querySelectorAll('.vm-option');

      function selected() {
        var vals = [];
        fieldsets.forEach(function (fs) {
          var c = fs.querySelector('input:checked');
          vals.push(c ? c.value : null);
          var lab = fs.querySelector('legend span');
          if (lab && c) lab.textContent = c.value;
        });
        return vals;
      }
      function markAvailability(vals) {
        fieldsets.forEach(function (fs, idx) {
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = vals.slice(); test[idx] = inp.value;
            var match = variants.find(function (v) { return v.options.every(function (o, i) { return o === test[i]; }); });
            var label = fs.querySelector('label[for="' + inp.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !match || !match.available);
          });
        });
      }
      function update() {
        var vals = selected();
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === vals[i]; }); });
        markAvailability(vals);
        if (!btn) return;
        if (!v) {
          btn.setAttribute('disabled', 'disabled');
          if (btnText) btnText.textContent = labels.unavailable;
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.disabled = false; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (priceEl) priceEl.textContent = formatMoney(v.price, moneyFormat);
        if (compareEl) {
          var onSale = v.compare && v.compare > v.price;
          compareEl.textContent = onSale ? formatMoney(v.compare, moneyFormat) : '';
          compareEl.hidden = !onSale;
          if (badgeEl) badgeEl.hidden = !onSale;
        }
        if (v.available) { btn.removeAttribute('disabled'); if (btnText) btnText.textContent = labels.add; }
        else { btn.setAttribute('disabled', 'disabled'); if (btnText) btnText.textContent = labels.sold; }
        showMedia(v.media);
        if (sec.dataset.updateUrl === 'true' && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });
      if (fieldsets.length) markAvailability(selected());

      sec.querySelectorAll('[data-vm-qty]').forEach(function (q) {
        var input = q.querySelector('input');
        q.querySelectorAll('button').forEach(function (b) {
          b.addEventListener('click', function () {
            var n = parseInt(input.value, 10) || 1;
            n += b.dataset.step === 'up' ? 1 : -1;
            input.value = Math.max(1, n);
          });
        });
      });
    });
  }

  function initAll(root) {
    initReveals(root);
    initHero(root);
    initCards(root);
    initRitual(root);
    initManifesto(root);
    initParallax(root);
    initFaq(root);
    initProduct(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { initAll(); });
  else initAll();
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
